// Browser tracing is on when the web server says so (WEB_BROWSER_TRACING=on writes this meta into the page; dev
// only): one image for every environment, and the SDK is a lazy chunk that a page without the meta never loads.

/** The meta element the web server writes when browser tracing is on (@cortex/web-host withBrowserTracingMeta). */
export const BROWSER_TRACING_META = 'cortex-browser-tracing';

export function browserTracingOn(doc: Document = document): boolean {
  return doc.querySelector<HTMLMetaElement>(`meta[name="${BROWSER_TRACING_META}"]`)?.content === 'on';
}
